import { format, isValid, parseISO } from 'date-fns';

export const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(value);
};

export function formatDate(dateString: string, fullTime?: boolean): string {
  const dateWithoutZ = dateString.replace('Z', '');
  const baseDate = parseISO(dateWithoutZ);

  return fullTime
    ? format(baseDate, 'dd/MM/yyyy HH:mm')
    : format(baseDate, 'dd/MM/yyyy');
}

export function removeEmptyFields(data: any) {
    Object.keys(data).forEach((key) => {
        if (data[key] === undefined || data[key] === null) {
            delete data[key];
        }
    });
    return data;
}